module.exports = __webpack_public_path__ + "img/class.07ce2e73.png";